import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEurope = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#0052B4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 3.5625L12.4495 4.94348H13.8955L12.7203 5.79373L13.1698 7.18012L11.9946 6.32445L10.8194 7.18012L11.2689 5.79373L10.0937 4.94348H11.5451L12 3.5625ZM6.03201 6.03201L7.33176 6.69272L8.3553 5.66375L8.12785 7.09889L9.42218 7.75959L7.98704 7.98704L7.75959 9.42218L7.09889 8.12243L5.66375 8.3553L6.69272 7.32634L6.03201 6.03201ZM3.5625 12L4.94348 11.5505V10.1045L5.79373 11.2797L7.18012 10.8302L6.32445 12.0054L7.18012 13.1806L5.79373 12.7311L4.94348 13.9063V12.4549L3.5625 12ZM6.03201 17.968L6.69272 16.6682L5.66375 15.6447L7.09889 15.8722L7.75959 14.5778L7.98704 16.013L9.42218 16.2404L8.12243 16.9011L8.3553 18.3362L7.32634 17.3073L6.03201 17.968ZM12 20.4375L11.5505 19.0565H10.1045L11.2797 18.2063L10.8302 16.8199L12.0054 17.6755L13.1806 16.8199L12.7311 18.2063L13.9063 19.0565H12.4549L12 20.4375ZM17.968 17.968L16.6682 17.3073L15.6447 18.3362L15.8722 16.9011L14.5778 16.2404L16.013 16.013L16.2404 14.5778L16.9011 15.8776L18.3362 15.6447L17.3073 16.6737L17.968 17.968ZM20.4375 12L19.0565 12.4495V13.8955L18.2063 12.7203L16.8199 13.1698L17.6755 11.9946L16.8199 10.8194L18.2063 11.2689L19.0565 10.0937V11.5451L20.4375 12ZM17.968 6.03201L17.3073 7.33176L18.3362 8.3553L16.9011 8.12785L16.2404 9.42218L16.013 7.98704L14.5778 7.75959L15.8776 7.09889L15.6447 5.66375L16.6737 6.69272L17.968 6.03201Z",
			fill: "#FFDA44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0414 24.0001C15.0987 23.9896 18.1527 22.8181 20.4853 20.4855C25.1716 15.7992 25.1716 8.20118 20.4853 3.51489L3.51471 20.4855C4.18433 21.1551 4.91339 21.729 5.68491 22.2073L6.63322 22.7368C8.30493 23.5727 10.1312 23.9938 11.9586 24.0001H12.0414Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7421 21.9297L15.75 18.9376V23.4019C16.0227 23.3125 16.2928 23.213 16.5598 23.1035L17.9752 22.4102C18.2354 22.2606 18.4913 22.1005 18.7421 21.9297Z",
			fill: "#0052B4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25001 23.4019V18.9376L5.25787 21.9298C5.50867 22.1005 5.7645 22.2606 6.02473 22.4102L7.44033 23.1035C7.70727 23.213 7.97736 23.3125 8.25001 23.4019Z",
			fill: "#0052B4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.4018 15.7501C23.0586 16.7962 22.5679 17.8044 21.9296 18.7422L18.9375 15.7501H23.4018Z",
			fill: "#0052B4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.1027 7.43902C23.2125 7.70642 23.3121 7.97698 23.4017 8.25012H18.9375L21.9296 5.25806C22.1006 5.5093 22.261 5.7656 22.4108 6.02632L23.1027 7.43902Z",
			fill: "#0052B4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2501 9.75L9.75 14.2501V23.7884C10.4792 23.9269 11.2188 23.9975 11.9586 24H12.0414C12.7812 23.9975 13.5208 23.9269 14.25 23.7884V14.25H23.7884C24.0705 12.7643 24.0705 11.2357 23.7883 9.75H14.2501Z",
			fill: "#D80027"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4751 19.3657L17.8594 15.75H15.75L20.4853 20.4853C20.8425 20.1282 21.1724 19.7541 21.4751 19.3657Z",
			fill: "#D80027"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.63427 21.4751L8.25 17.8594V15.7501L3.51471 20.4854C3.87184 20.8425 4.24589 21.1724 4.63427 21.4751Z",
			fill: "#D80027"
		})
	] }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2003_27269",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export { SvgEurope as ReactComponent };
